







import XInput from 'vux/src/components/x-input/index.vue'

export default {
name: "chatframe",
components: {
XInput,
},
props: {
values:String,
itemValue:String,









},
data() {
return {
value:this.values
}
},
mounted() {
this.$emit("onTwoInput",this.value)
},
beforeDestroy() {

},
methods:{

onDelOneInput()
{
this.$emit("onDelTwoInput",1)
},
},
watch:{
value(value)
{
this.$emit("onTwoInput",value)
},
values(val)
{
console.log(val,"val");
this.value = val;
this.$emit("onTwoInput",val)
},
itemValue(val)
{
console.log(val,"val");
this.value = val;
this.$emit("onTwoInput",val)
}
}
}



// WEBPACK FOOTER //
// ./src/myComponents/twoInput/twoInput.vue